import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Check, X, ExternalLink } from 'lucide-react';
export function AdminVenueClaimsPage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-1216">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-1217">
        <div className="flex items-center gap-4" data-id="element-1218">
          <span className="text-xl font-bold text-red-500" data-id="element-1219">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-1220"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-1221">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-1222">
              Dashboard
            </Link>
            <Link to="/admin/venue-claims" className="text-textMain" data-id="element-1223">
              Venue Claims
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-1224">
        <div className="mb-8" data-id="element-1225">
          <h1 className="text-2xl font-bold mb-1" data-id="element-1226">Venue Claims</h1>
          <p className="text-sm text-textMuted" data-id="element-1227">
            Review and approve venue ownership requests.
          </p>
        </div>

        <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-1228">
          <table className="w-full text-sm text-left" data-id="element-1229">
            <thead className="text-xs text-textMuted uppercase bg-background/50 border-b border-border" data-id="element-1230">
              <tr data-id="element-1231">
                <th className="px-6 py-4 font-medium" data-id="element-1232">Venue</th>
                <th className="px-6 py-4 font-medium" data-id="element-1233">Claimant</th>
                <th className="px-6 py-4 font-medium" data-id="element-1234">Proof Provided</th>
                <th className="px-6 py-4 font-medium" data-id="element-1235">Status</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-1236">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-1237">
              {[{
              venue: 'The Empty Bottle (Chicago)',
              claimant: 'brent@emptybottle.com',
              proof: 'Domain Match',
              status: 'Pending'
            }, {
              venue: 'Beachland Tavern (Cleveland)',
              claimant: 'booking@gmail.com',
              proof: 'Utility Bill Uploaded',
              status: 'Pending'
            }].map((claim, i) => <tr key={i} className="hover:bg-surfaceHover/50 transition-colors" data-id="element-1238">
                  <td className="px-6 py-4 font-medium" data-id="element-1239">{claim.venue}</td>
                  <td className="px-6 py-4" data-id="element-1240">{claim.claimant}</td>
                  <td className="px-6 py-4" data-id="element-1241">
                    <span className="flex items-center gap-1 text-primary hover:underline cursor-pointer" data-id="element-1242">
                      {claim.proof} <ExternalLink className="w-3 h-3" data-id="element-1243" />
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1244">
                    <span className="px-2 py-1 bg-amber-500/10 text-amber-500 text-[10px] font-bold uppercase tracking-wider rounded" data-id="element-1245">
                      {claim.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-1246">
                    <div className="flex items-center justify-end gap-2" data-id="element-1247">
                      <button className="p-1.5 bg-green-500/10 text-green-500 hover:bg-green-500/20 rounded transition-colors" data-id="element-1248">
                        <Check className="w-4 h-4" data-id="element-1249" />
                      </button>
                      <button className="p-1.5 bg-red-500/10 text-red-500 hover:bg-red-500/20 rounded transition-colors" data-id="element-1250">
                        <X className="w-4 h-4" data-id="element-1251" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>;
}